import { createRouter, createWebHistory } from "vue-router";

import Home from "@/views/HomePage.vue";
import Service from "@/views/ServicePage.vue";

const routes = [
    {
        path: "/",
        name: "HomePage",
        component: Home,
    },

    {
        path: "/service",
        name: "ServicePage",
        component: Service,
    },
	
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)
        {
            return savedPosition;
        }
        else
        {
            return {
                top: 0,
                behavior: 'smooth',
            }
        }
    },
});

export default router;
